import React from 'react'
import { OrderRatingForm } from './OrderRatingForm/OrderRatingForm'
import { OrderRatingsDialog } from './OrderRatingsDialog'

export function FormOrderRatingsDialog ({
  onSubmit,
  isOpen,
  closeable = true,
  ratingFormInitialValues,
  formSchema,
  ratingFields,
  disabled,
}) {
  function handleSubmit (values) {
    onSubmit(values)
  }

  const handleDismiss = () => {
    if (closeable) {
      onSubmit(null)
    }
  }

  return (
    <OrderRatingsDialog
      onClose={handleDismiss}
      isOpen={isOpen}
      closeable={closeable}>
      <OrderRatingForm values={ratingFormInitialValues}
                       onSubmit={handleSubmit}
                       disabled={disabled}
                       schema={formSchema}
                       fields={ratingFields}/>
    </OrderRatingsDialog>
  )
}
